import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

import {jobTitle} from '../../../../../utils';

const JobNameView = (props) => {
  const {
    jobData,
    client,
  } = props;

  const clientName = client?.clientDetail?.clientName ||
    jobData.client?.unregisteredClient ||
    'Unknown Client';
  const title = jobTitle(jobData, clientName, {
    location: 'career.jobDetail.Title',
    languages: 'career.jobDetail.TitleLanguages',
    clientOnly: 'career.jobDetail.TitleClientOnly',
  });

  return (
    <Box>
      <Typography sx={{fontSize: '28px', fontWeight: 400}}>
        <Translate expression={title.expression} substitute={title.substitute} />
      </Typography>
    </Box>
  );
};

JobNameView.propTypes = {
  jobData: PropTypes.object.isRequired,
  client: PropTypes.object,
};

export default React.memo(JobNameView);
